
import { Route, Link } from 'react-router-dom'
import { Template } from './Template'
import { Routes } from 'react-router-dom'
import App from './App'
import { FAQ } from './faq/FAQ'
import { Pricing } from './prices/Prices'
import { Contact } from './contact/Contact'
import { Download } from './download/Download'
export default function Router() {
  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/download" element={<Download />} />
      <Route path="*" element={<Template><section className="main-container"><span className="eyebrow">404 / OFF THE BUILD PLATE</span><h1>This page isn't here.</h1><p className="page-description">Let's get you back to something worth creating.</p><Link className="button button-primary" to="/">Back to overview</Link></section></Template>} />
    </Routes>
  )
}
